// extracted by mini-css-extract-plugin
export default {"error":"Error-module__error--rekBm","error__title":"Error-module__error__title--dC2Qm","error__link":"Error-module__error__link--FKZLu"};